export default {
  bank: "Bangko",
  winlose: "Panalo/Katalo",
  balance: "Balanse",
  win: "Panalo",
  lose: "Katalo",
  tie: "Sabay",
  history: "Kasaysayan",
  transfer_details: "Mga Detalye ng Paglipat",
  id: "ID",
  game: "Laro",
  contactus: "Kontak",
  join_now: "Sumali Ngayon",
  manual_deposit: "Manual na Deposito",

  aboutus: "Tungkol Sa Amin",
  attention: "Pansin",
  amount_currency: "Halaga ({currency} Min: {min} Max: {max})",
  all: "Lahat",
  amount: "Halaga",
  approved: "Aprubado",
  and: "at",
  atm_cash: "TM/Deposito ng Pera",
  account_name: "Pangalan ng Account",
  account_no: "Numero ng Account",
  amount_min: "Pinakamababang Halaga",
  amount_max_short: "Pinakamataas na Halaga",
  amount_not_min: "Hindi umabot ang halaga sa minimum na kinakailangan",
  amount_max:"Lumampas sa maksimum na limitasyon ang halaga.",
  add_bank: "Magdagdag ng Bangko",
  account_id: "ID ng Account",
  adjustment_details: "Detalye ng Pagsasaayos",
  after_balance: "Matapos ang Balanse",
  android: "Android",
  atm: "ATM",
  acc_detail: "Detalye ng Account",
  amount_receive: "Natanggap na Halaga",
  active_player: "Kabuuang AKTIBONG MGA MANLALARO",
  affiliate_code: "Code ng Affiliate",
  admin: "Admin",
  admin_open: "Kung may problema kang tumanggap ng OTP code, maari kang makipag-ugnayan sa amin sa pamamagitan ng Live Chat",
  attachment_tips: "Mangyaring mag-upload ng resibo ng iyong transaksyon",
  accounts: "Mga Account",
  active: "Aktibo",

  bank_accname: "May-ari ng Account",
  bank_accno: "Numero ng Account",
  bank_name: "Pangalan ng Bangko",
  bank_detail: "Detalye ng Bangko",
  bet_history: "Kasaysayan ng Pustahan",
  bank_account: "Account sa Bangko",
  better_luck: "Masuwerte ka sa susunod na pagkakataon!",
  birthday: "Kaarawan",
  bonus_details: "Detalye ng Bonus",
  before_balance: "Bago ang Balanse",
  bonus_value: "Halaga ng Bonus",
  bonus: "Bonus",
  bank_ewallet: "E-Wallet",
  bank_ewalletname: "May-ari ng E-Wallet",
  bank_ewalletno: "Numero ng E-Wallet",

  cdm: "CDM",
  counter: "Tindahan/Kiosk",
  cancel: "Kanselahin",
  change_password: "Baguhin ang Password",
  confirm_password: "Kumpirmahin ang Password",
  close: "Isara",
  claim: "Kunin",
  claim_now: "kunin ngayon",
  current_balance: "Kasalukuyang Balanse",
  cash_deposit: "Deposito ng Pera",
  contact_for_bank: "Makipag-ugnayan sa Livechat ng EpicWin",
  congratulations: "Batiin Ka!",
  contact_number: "Numero ng Kontak",
  claim_rewards: "Kunin ang Mga Gantimpala",
  cash_value: "Halaga ng Pera",
  customer_review: "Mga Pagsusuri ng EpicWin",
  claim_offer: "Kunin ang aking alok!",
  custom_description: {
    comment_placeholder: "Iwanan ang iyong mga komento dito.",
    review_complete_header: "Salamat sa pagpapakalat ng Magandang Vibes!",
    review_complete_text: "Gagamitin namin ito upang mapabuti ang produkto.",
  },
  count: "Bilang",
  click_here: "I-click Dito",
  change: "Baguhin",
  coupon: "Kupong-gantimpala",
  category: "Kategorya",
  choose_promo: "Pumili ng Promosyon",
  choose_nopromo: "Huwag sumali sa anumang mga promosyon.",

  deposit: "Deposito",
  deposit_short: "Deposito",
  deposit_enter: "Mangyaring maglagay ng halaga ng deposityo",
  deposit_method: "Deposit Method - Paraan ng Deposito",
  deposit_method_select: "Mangyaring pumili ng paraan ng deposityo",
  deposit_reminder: "Naintindihan ko at sumasang-ayon ako sa lahat ng nakasaad na",
  deposit_reminder_two: "ukol sa mga bonus at/o mga kinakailangang pag-withdraw",
  download: "I-download",
  download_android: "I-download para sa Android",
  download_ios: "I-download para sa iOS",
  date: "Petsa",
  date_expiry:"Petsa ng pagtatapos",
  done: "Tapos na",
  deposit_now: "Magdeposito Ngayon",
  description: "Deskripsyon",
  deposit_tnc: "Deposito - Libreng Jackpot Tickets",
  developer_response: "Tugon ng Developer",
  daily_update: "Araw-araw na Pagsasapanahon",
  downloadgame: "I-download ang Laro",
  deposit_min:"Min. Deposito",
  details:"Mga Detalye",

  email: "Email",
  enter_bank_accname: "Mangyaring maglagay ng pangalan ng may-ari ng bank account",
  enter_bank_accno: "Mangyaring maglagay ng numero ng bank account",
  enter_ewallet_name: "Pakipunan ang pangalan ng may-ari ng E-Wallet",
  enter_ewallet_no: "Pakipunan ang numero ng E-Wallet",
  eta: "Inaasahan na Oras ng Pagdating",
  epic_production: "Produksyon ng EPIC",
  edit: "i-edit",

  female: "Babae",
  failed: "Nabigo",
  forgot_password: "Nakalimutan ang Password?",
  faq: "Madalas Itanong",
  for_android: "Para sa Android",
  for_ios: "Para sa iOS",
  find_out: "Alamin Pa",
  file_choose: "Pumili ng File",
  file_upload: "Mag-upload ng File",
  file_requirement: "Hindi puwedeng lampas sa 1MB ang laki ng file at dapat nasa format ng png, jpg, o jpeg",
  full_name: "Buong Pangalan",
  fill_stars: "Maaring magbigay ka ng iyong rating bago magpatuloy",
  full_phone: "Numero ng Telepono",
  full_referral: "Code ng Referral",

  gender: "Kasarian",
  game_play: "Paglalaro ng Laro",
  game: "Laro",
  get: "Kunin",
  gcash_reminder: "Sa mga unang deposito, kinakailangan ang GCash face scan, ngunit huwag mag-alala, hindi na ito kinakailangan sa mga sumusunod na transaksyon at garantisadong walang abala!",

  hi: "Hi,",
  has_won: "Nakamit na",
  has_won_rate: "Porsyento ng Panalo",
  has_withdraw: "Nakapag-withdraw na",
  hourly_update: "Buwanang Pagsasapanahon",
  hot_movie: "Mainit na mga Pelikula",

  ios: "iOS",
  inactive: "hindi aktibo.",

  jackpot: "Jackpot",
  join_us: "Sumali sa amin",

  leaderboard_title: "TOP 15 NA MGA MANLALARO NA MAY PINAKAMARAMING MAGIC SPINS",
  login: "Mag-Login",
  logout: "Mag-Logout",
  login_now: "Mag-Login Na",
  lucky_spin: "suwerteng spin para manalo ng hanggang PHP{value}",
  latest_transactions: "Pinakabagong mga Transaksyon",
  lucky_wheel: "Suwerteng Gulong",
  loyalty_points: "mga puntos ng pagkamalikhain",
  last_4_digits: "Huling 4 na Digito ng Numero ng Telepono",
  last_login: "Huling Pag-Login",
  lang_en: "Ingles",
  lang_zh: "Tsino",
  lang_my: "Malay",
  luckydraw_announcement: "Makakakuha ka ng mga Tiket para sa Suwerte na Pagsusulay sa Bawat Tagumpay na Deposito<br>Manatili Para sa Live na Suwerteng Pagsusulay<br>19 Abril 2021, 7.30pm",
login_otp: "Mag-login gamit ang OTP",
login_pass: "Mag-login gamit ang password",

  male: "Lalaki",
  mobile: "Mobile",
  minigames: "Mga Mini Laro",
  method: "Paraan",
  min: "Min",
  min_amount: "Pinakamababang Halaga",
  monthly_update: "Buwanang Pagsasapanahon",
  movies: "Mga Pelikula",
  movie_watch: "Panuorin Ngayon",
  max: "Max",

  name: "Pangalan",
  next: "susunod",
  new_password: "Bagong Password",
  no_account_yet: "Wala pang Account?",
  no_win: "Hindi ka nanalo ng kahit ano sa pagkakataong ito",
  nickname: "Palayaw",
  next_update_time: "Susunod na Oras ng Pagsasapanahon",
  no_bonus_found: "Walang detalye ng bonus na natagpuan",
  no_adjustment_found: "Walang natagpuang detalye ng pag-aayos",
  no_new_gifts: "Walang bagong mga regalo",
  no: "Numero",
  no_contact: "Walang available na kontak!",
  no_new_message: "Walang bagong mensahe",
  newsletter: "Gusto kong malaman ang mga alok at promosyon sa pamamagitan ng email, text o post",

  others: "Iba",
  offical_team: "Opisyal na Koponan",
  online: "ONLINE",
  online_banking: "Online na Bangko",
  online_banking_set: "Online na Bangko ({bank})",
  option: "Opsyon {0}",
  optional: "Opsyonal",
  old_password: "Lumang Password",
  ok: "Okey",
  current_password: "Kasalukuyang Password",
  operator_bank_list: "Listahan ng mga Bankeng Operator",
  promotion_selected: "Napili ang Promosyon",

  pending: "Nakabinbin",
  play_now: "Maglaro Ngayon",
  password: "Password",
  password_signup: "Password",
  phone_number: "Numero ng Telepono",
  promotion: "Promosyon",
  promotions: "Mga Promosyon",
  promotion_select: "Mangyaring Pumili ng Promosyon / Walang Promosyon",
  profile: "Profile",
  privacy_policy: "Patakaran sa Privacy",
  privacy_statement: "Pahayag sa Privacy",
  password_tips: "Ang password ay dapat na 6-20 na karakter.",
  phone_tips: "Tamang numero ng telepono LANG halimbawa: +63 9163451812, walang puwang",
  problem_contact: "Kung may problema kang natatanggap ng code, mangyaring makipag-ugnayan sa amin sa pamamagitan ng Live Chat.",
  reset_tips: "Mangyaring maglagay ng huling 4 na digit ng iyong numero ng telepono",
  prev: "Bumalik",
  please_select: "Mangyaring Pumili",
  please_select_bank: "Mangyaring Pumili ng Banko",
  please_select_ewallet: "Pumili ng E-Wallet",
  please_select_payment: "Mangyaring pumili ng paraan ng pagbabayad",
  progress: "Progreso",
  promotion_bonus: "Bonus ng Promosyon",
  promotion_details: "Mga Detalye ng Promosyon",
  phone_no_reminder_recipient: "Mangyaring punan ang numero ng telepono ng tatanggap",
  phone_recipient_same: "Hindi puwedeng pareho ang numero ng telepono ng tatanggap at ng nagpadala",
  promo_select: "Mangyaring Pumili ng Promosyon",
  promo_none: "Walang Promosyon",
  payment_option: "Paraan ng Bayad",
  personal_info: "Personal na Impormasyon",
  payment_info: "Impormasyon sa Pagbabayad (BANK)",
  payment_channel: "Paraan ng Pagbabayad",
  processing: "Nagproseso",
  payment_gateway: "Gateway para sa pagbabayad",

  ref_num_enter: "Mangyaring maglagay ng reference number",
  register: "Magparehistro",
  register_now: "Magparehistro Na",
  responsible_gambling: "Responsableng Paghuhusga sa Pagnanais",
  responsible_gaming: "Responsableng Paglalaro",
  rebate: "Rebate",
  rejected: "Tiniwalag",
  result: "RESULTA",
  reward: "Gantimpala",
  rewards: "Mga Gantimpala",
  referral: "Pagsasangkot",
  referral_link: "Link ng Pagsasangkot:",
  referral_prefix: "Mag-Refer at kumita ng cashback hanggang PHP20 para sa bawat bagong Referred Friend na non-promo deposit! Link:",
  referral_code: "Code ng Pagsasangkot",
  resend: "Ipadala ulit",
  request_again: "Humiling ng OTP",
  reference_number: "Numero ng Sanggunian",
  reference_number_tooltips: "Mangyaring maglagay ng numero ng sanggunian",
  remarks: "Mga Puna",
  real_time: "Totoong Oras",
  recipient_id: "ID ng Tatanggap",
  review: "Pagsusuri | pagsusuri",
  review_title: "Bigyan ng Pagsusuri ang Iyong EPIC Game Journey",
  registered_player: "Kabuuang Bilang ng Naka-Rehistrong Manlalaro",
  register_title: "Magparehistro Ngayon at Makakuha ng Libreng Angpow",

  save: "i-save",
  send: "Ipadala",
  social_responsibility: "panlipunang responsibilidad",
  status: "Katayuan",
  slotgames: "Mga Slot",
  slot_play: "Maglaro",
  slot_games: "Mga Laro sa Slot",
  slot_games_mobile: "Mga Laro sa Mobile Slot",
  signup: "Mag-Sign Up",
  submit: "Isumite",
  select_bonus: "Mangyaring Pumili ng Bonus / Walang Bonus",
  spin_again: "IKUTAN MULI",
  success: "Tagumpay",
  share: "Ibahagi",
  share_title: "Ibahagi sa:",
  share_invite_code: "Ibahagi ang iyong code na paanyaya",
  share_facebook: "Ibahagi sa Facebook",
  share_to_friend: "Ibahagi sa Kaibigan",
  share_referral_reward: "Kumuhang PHP 10.00 para sa inyo pareho at sa iyong kaibigan",
  select_deposit: "Mangyaring pumili ng paraan ng pagdedeposito",
  single_highest: "Iisang Taya na may Pinakamataas na Bayad",
  signup_success: "Matagumpay na nilikha ang iyong account",
  skip: "Talukbong",
  setting: "Setting",

  tac_tips: "Kung may problema ka sa pagtanggap ng OTP code, mangyaring i-click ang buton ng live chat",
  time: "Oras",
  tutorials: "Mga Tutorial",
  type: "Uri",
  transfer: "Transfer",
  transfer_amount: "Halaga ng Transfer",
  transaction_history: "Kasaysayan ng Transaksiyon",
  transfer_history: "Kasaysayan ng Transfer",
  tnc: "T&C (Mga Tuntunin at Kundisyon)",
  tnc_full: "Mga Tuntunin at Kundisyon",
  tnc_accept_reminder: "Mangyaring i-tsek ang kahon upang sumang-ayon sa aming mga tuntunin at kundisyon",
  ticket_status:{
    "0": "Tinanggihan",
    "1": "Aprubado",
  },
  tac_code: "OTP Code",
  tac_code_new: "Ang Bagong OTP Code ay ipinadala sa iyong numero ng telepono",
  topten_WITHDRAWAL: "Nag-Wiwithdraw",
  topten_DEPOSIT: "Nag-Deposito",
  transaction: "Transaksiyon",
  tutorial_deposit: "Paano Magde-deposit - Sa App",
  tutorial_withdrawal: "Paano Magwi-withdraw - Sa App",
  tutorial_transfer: "Paano Mag-Transfer - Sa App",
  tutorial_android: "Paano I-download - Android",
  tutorial_ios: "Paano I-download - IOS",
  transfer_fee: "Bayad sa Pag-Transfer",
  thankyou:{
    header: "Maligayang pagdating sa Pamilya ng Epic.",
    description: "Bawat miyembro ay tatanggap ng token ng pagpapahalaga.",
  },
  total_withdrawal: "BUWANANG BILANG NG PAG-WIWITHDRAW",
  total_review: "BUWANANG BILANG NG PAGSUSURI",
  top_games: "TOP 10 SIKAT NA LARO",
  topgames_period: "HULING 30 ARAW",

  username: "Username",
  uh_oh: "Uh-oh!",
  statement: "Pahayag",
  upload_file: "Mag-Upload ng File",
  upload_file_tooltips: "Hindi dapat lumampas sa 1MB ang laki ng file at dapat nasa png, jpg, o jpeg format ito",
  update: "update",
  update_email: "I-update ang Email",
  update_email_success: "Matagumpay na na-update ang Email",
  unknown: "Hindi Kilala",

  verification_number: "SMS OTP Code",
  view_transaction_history: "tingnan ang kasaysayan ng transaksyon",
  view_transaction: "Maaring tingnan ang kasaysayan ng transaksyon hanggang 90 araw.",
  verification_no_required: "Kailangan ang OTP Code",
  phone_no_reminder: "Mangyaring maglagay ng huling 4 digit ng iyong numero ng telepono",
  videos: "Mga Video",
  video_link: "URL ng Video",

  withdrawal: "Pag-Wiwithdraw",
  withdraw_required: "Kinakailangang halaga ng pag-wiwithdraw.",
  withdraw_greater_50: "Ang halaga ng pag-wiwithdraw ay dapat na mas mataas o pantay sa 50.",
  worth: "Halaga",
  withdrawal_details: "Detalye ng Pag-Wiwithdraw",
  withdrawal_details1: "Bilang ng mga Pag-Wiwithdraw: 5 beses kada araw",
  withdrawal_details2: "Tagal: 1 minuto: RM10,000",
  withdrawal_details3: "Tagal: 3 minuto: RM100,000 at Higit Pa",
  withdrawal_speed: "BILIS NG PAG-WIWITHDRAW",
  withdrawal_epic: "EPIC NA PAG-WIWITHDRAW",
  withdrawal_topten: "TOP 10 PAG-WIWITHDRAW",
  winner_topten: "TOP 10 EPIC NA MGA NANALO",
  withdrawal_reminder: "Paalala: Upang maiwasan ang pagkakawalang-bisa ng iyong balanse, pakitandaan na i-withdraw ang buong halaga kung ikaw ay kukuha ng anumang promosyon.",  

  you_won: "Nanalo ka sa",
  you_have: "Mayroon ka",
  withdraw_target_tips: "Kailangan mong abutin ang target para sa pag-wiwithdraw",


  rebate_toclaim: "Puwedeng Makuha na Rebate",
  rebate_total: "Kabuuang Rebate",
  adjustment: "Ajustment",
  game_name: "Pangalan ng Laro",
  referee: "referee",
  platform: "plataporma",
  provider: "tagapagbigay",
  turnover: "turnover",
  inbox: "Inbox",
  bank_profile: "profile ng bangko",
  attachment: "attachment",
  completed: "tapos na",
  worldcup: "world cup",
  no_record: "Walang Natagpuang Rekord",
  earn_rebated: "Kita mula sa Rebate",
  turnover_amount: "Halaga ng Turnover",
  acc_turnover: "Pinagsama-samang Turnover",
  earn_ticket: "Tiket na Natamo",
  total_downline: "Total Downline - Kabuuang Downline",
  submit_predict: "magsumite ng prediksyon",
  coming_soon: "lalabas na sa lalong madaling panahon",
  fill_predict: "Pakipunan ang iyong prediksyon",
  step_one: "hakbang 1",
  home: "bahay",
  slot: "slot",
  slots: "mga slot",
  games: "mga laro",
  livecasino: "live casino",
  live: "live",
  casino: "casino",
  fishing: "pangingisda",
  sportsbook: "sportsbook",
  sports: "sports",
  book: "aklat",
  cockfight: "sabong manok",
  real_time_trans: "Transaksyon sa Totoong Oras",
  copy_referral: "Kopyahin ang Link ng Pag-refer",
  invite_friend: "Mag-imbita ng Kaibigan!",
  bet_time: "oras ng pustahan",
  bet_empty: "Ang iyong listahan ng pustahan ay walang laman",
  result_empty: "Walang resulta",
  error_button: "BUMALIK SA PAMAHALAANANG PAGKAKASALO",
  new_member: "bagong miyembro",
  special: "espesyal",
  daily: "araw-araw",
  redeem: "magkabayaran",
  bet_list: "Talaan ng Pustahan",
  notice: "Abiso",
  notice_welcome: "Welcome to EpicWin! Unlock 15% Bonus on Your First Daily Deposit! Play now and win big!",
  statement_daily: "raw-araw na Pahayag",
  campaign: "kampanya",
  worldcup_2022: "World cup 2022",
  turnover_downline: "Kabuuang Turnover ng Downline",
  daily_rebate: "Araw-araw na Rebate sa Laro",
  redeem_ticket: "Magkabayaran ng Tiket",
  back: "bumalik",
  ticket: "Tiket",
  claimed_ticket: "Mga Tiket na Kinuhang Na",
  ftd_message: "Binabati kita, ikaw ay nabigyan ng 30k, kunin mo na ito ngayon!",
  free_credit_message: "Ang Libreng Kredito ay maaaring gamitin lamang sa mga laro ng EpicWin",
  deposit_amount: "Halaga ng Deposito",
  self_rebate_rate: "porsyento ng sariling rebate",
  downline_rebate_rate: "porsyento ng rebate ng downline",
  more_info: "Karagdagang Impormasyon",
  info: "Impormasyon",
  item: "Item",
  follow_us: "Sundan Kami",
  payment_method: "Paraan ng Pagbabayad",
  certification: "Sertipikasyon",
  username_guide: "Ang username ay dapat na 6-20 na karakter.",
  trans_time: "Oras ng Transaksyon",
  event: "Kaganapan",
  odds: "Odds",
  odd: "Odd",
  stake: "Pusta",
  ref_no: "Numero ng Ref.",
  lost: "Talo",
  draw: "Tabla",
  american_football: "Amerikanong Football",
  soccer: "Futbol",
  basketball: "Basketbol",
  baseball: "Baseball",
  esports: "E-Sports",
  esports2: "E-Sports",
  tennis: "Tennis",
  even: "Pares",
  over: "Over",
  under: "Under",
  slot_custom: "Slot",
  sb_custom: "Sportsbook",

};
